import Vue from 'vue'
import Router from 'vue-router'
//首页
import index from "../components/index/home.vue"
//搜索结果页
import searchResList from "../components/index/searchResList.vue"
//图片列表页
import picList from "../components/index/picList.vue"
//图片详情页
import picDetail from "../components/index/picDetail.vue"
//文章列表页
import artList from "../components/index/artList.vue"
//文章详情页
import artDetail from "../components/index/artDetail.vue"
//我要分享
import share from "../components/share/index.vue"
import sharePhoto from "../components/share/sharephoto.vue"
import shareArtical from "../components/share/shareartical.vue"
import shareppt from "../components/share/shareppt.vue"
//新闻公告

//登录
import login from "../components/common/login.vue"
//个人中心
import homePage from "../components/homePage/index.vue"
import homeOriginal from "../components/homePage/original.vue"
import homeCollect from "../components/homePage/collect.vue"
import homeCollectDetail from "../components/homePage/collectDetail.vue"

import accountSetting from "../components/accountsetting/index.vue"
import personMessage from "../components/personMessage/index.vue"
import message from "../components/personMessage/message.vue"
import dynamic from "../components/personMessage/dynamic.vue"

import news from "../components/news/index.vue"
import newsList from "../components/news/newslist.vue"
import newsDetails from "../components/news/newsdetails.vue"

import personInfo from "../components/otherInfo/info.vue"
import personOriginal from "../components/otherInfo/original.vue"
import personCollect from "../components/otherInfo/collect.vue"

import notFound from "../components/common/notfound.vue"
// 使用帮助
import help from "../components/help/help.vue"

Vue.use(Router)

import {getToken} from "@/assets/js/modules/auth"
import {justifyInfo} from "@/assets/js/modules/utils"
export const constantRoutes = [
  //首页
  {
    path: "/",
    component: index
  },
  //搜索结果页
  {
    path: "/searchResList",
    component: searchResList
  },
  //公司资料
  {
    path: "/companyInfo",
    // redirect: "/companyInfo/blocVI",
    component: picList,
    children: [{
      path: "/companyInfo/blocVI",
      component: picList
    },
    {
      path: "/companyInfo/parkSource",
      component: picList
    },
    {
      path: "/companyInfo/amimationSource",
      component: picList
    },
    {
      path: "/companyInfo/cprPhoto",
      component: picList
    },
    {
      path: "/companyInfo/cprFont",
      component: picList
    },
    {
      path: "/companyInfo/groupPPT",
      component: picList
    },
    {
      path: "companyInfo/parkSource",
      component: picList
    }
  ]
  },
  //创意图片
  {
    path: "/creativePhoto",
    component: picList,
    children: [{
        path: "/creativePhoto/parkPhoto",
        component: picList
      },
      {
        path: "/creativePhoto/xcmPhoto",
        component: picList
      },
      {
        path: "/creativePhoto/freeCpr",
        component: picList
      },
      {
        path: "/creativePhoto/ppt",
        component: picList
      }
      
    ]
  },
  //创意图片详情页
  {
    path: "/picDetail",
    component: picDetail
  },
  //设计交流
  {
    path: "/designExchange",
    component: picList,
    children: [{
      path: "/designExchange/originalProduct",
      component: picList
    },
    {
      path: "/designExchange/shareExperience",
      component: artList
    }
  ]
  },
 //设计交流详情页
  {
    path: "/artDetail",
    component: artDetail
  },
  //我要分享
  {
    path: "/share",
    redirect: "/share/photo",
    component: share,
    children: [{
        path: "/share/photo",
        component: sharePhoto
      },
      {
        path: "/share/artical",
        component: shareArtical
      },
      {
        path: "/share/ppt",
        component: shareppt
      }
    ]
  },
  //个人中心
  {
    path: "/news",
    redirect: "/news/newslist",
    component: news,
    children: [{
        path: "/news/newslist",
        component: newsList
      },
      {
        path: "/news/newsdetails/",
        component: newsDetails
      },
    ]

  },
  {
    path: "/homepage",
    redirect: "/homepage/original",
    component: homePage,
    children: [{
        path: "/homepage/original",
        component: homeOriginal
      },
      {
        path: "/homepage/collect",
        component: homeCollect
      },

    ]
  },
  //收藏夹详情
  {
    path: "/homepage/collectDetail/:favoritesId/:favoritesName",
    component: homeCollectDetail
  },
  //登录
  {
    path: "/login",
    component: login
  },
  //账户设置
  {
    path: "/setting",
    component: accountSetting
  },
  // 使用帮助
  {
    path: "/help",
    component: help
  },
  //个人消息
  {
    path: "/message",
    redirect: "/message/message",
    component: personMessage,
    children: [{
        path: "/message/message",
        component: message
      },
      {
        path: "/message/dynamic",
        component: dynamic
      }
    ]
  },
  //他人信息
  {
    path: "/personInfo/",
    component: personInfo,
    name: "other",
    redirect: "/personInfo/original",
    children: [
      {
        path: "/personInfo/original",
        component: personOriginal,
        name: "otherOriginal"
      },
      {
        path: "/personInfo/collect",
        component: personCollect,
        name: "otherCollect"
      }
    ]
  },
  {
    path: "/404",
    component: notFound,
    name: "notFound",
    meta: {
      title: "404~页面找不到啦~"
    }
  },
  {
    path: "*",
    redirect: "/404"
  }
]

const createRouter = () => new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
});

const router = createRouter();
 
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach(async (to, from, next) => {
  const nextRouter = [
    '/homepage/original',
     '/homepage/collect', 
     '/setting', 
     '/message/message', 
     '/message/dynamic', '/share', 
     '/share/photo', 
     '/share/artical',
     '/share/ppt',
     '/companyInfo/blocVI',
     '/companyInfo/parkSource',
     '/companyInfo/amimationSource',
     '/companyInfo/cprPhoto',
     '/companyInfo/groupPPT',
     '/companyInfo/cprFont'
    ];
    
  await justifyInfo();
  const hasToken = getToken();
  if (hasToken) {
    if (to.path === "/login") {
      next({
        path: "/"
      })
    } else {
      next();
    }
  } else {
    //no token
    if (nextRouter.indexOf(to.path) !== -1) {
      next(`/login?redirect=${to.fullPath}`)
    } else {
      next();
    }
  }
})

router.afterEach((to,from) => {
  if(to.meta.title && to.name=="notfound"){
    document.title = to.meta.title;
  }else if(!to.name || to.name.indexOf("other")!=-1){
    document.title = "华强方特图库网";
  }
});
export default router
 


// WEBPACK FOOTER //
// ./src/router/index.js